class CollectionPaginationNumbers extends HTMLElement
{
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', this.onClick);
    });
  }

  onClick(e) {
    e.preventDefault();
    const a = e.currentTarget;
    if (!a) return;

    const href = a.getAttribute('href');
    if (!href) return;

    const url = new URL(href, window.location.origin);
    const searchParams = url.searchParams.toString();

    // Si les facets existent, on délègue au moteur officiel (section rendering + cache + counts + pills)
    if (window.customElements?.get('facet-filters-form') && typeof FacetFiltersForm?.renderPage === 'function') {
      FacetFiltersForm.renderPage(searchParams, null, true);
      return;
    }

    // Fallback : comportement actuel (au cas où facets.js n’est pas chargé)
    const productGrid = document.getElementById('ProductGridContainer');
    if (!productGrid) return;
    const collectionEl = productGrid.querySelector('.collection');
    if (collectionEl) collectionEl.classList.add('loading');

    fetch(url.toString())
      .then(r => r.text())
      .then((responseText) => {
        const parsed = new DOMParser().parseFromString(responseText, 'text/html');
        const next = parsed.getElementById('ProductGridContainer');
        if (next) productGrid.innerHTML = next.innerHTML;
        if (window.updateCollectionDescription) window.updateCollectionDescription(parsed);

        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`);
        const nextCollectionEl = productGrid.querySelector('.collection');
        if (nextCollectionEl) nextCollectionEl.classList.remove('loading');
        productGrid.scrollIntoView({ behavior: 'smooth' });
      });
  }
}

customElements.define('collection-pagination-numbers', CollectionPaginationNumbers);
